import { Search } from "@pjs/core-ui";
import { react2angular } from "@pebblepad/react2angular";
import { angularAMD } from "@pebblepad/amd";

angularAMD.component(
    "searchComponent",
    react2angular(Search, ["onSearch", "onChange", "searchString", "clearSearchLabel", "searchButtonLabel", "searchInputLabel", "disabled", "placeholder", "className", "autoFocus", "dataHooks"])
);
